(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hira-carousel-band"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const track = root.querySelector('[data-hira-carousel-track]');
      const prev = root.querySelector('[data-hira-carousel-prev]');
      const next = root.querySelector('[data-hira-carousel-next]');
      if (!track || !prev || !next) return;

      const step = () => {
        const card = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
      };
      const update = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      };

      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    };

    // UGC videos: muted, only download/play while on screen
    const videos = () => document.querySelectorAll('[data-hira-ugc]');
    const io = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
          entries.forEach(({ target, isIntersecting }) => {
            if (isIntersecting) target.play().catch(() => {});
            else target.pause();
          });
        }, { threshold: 0.6 })
      : null;
    const setupVideos = () => {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      videos().forEach((video) => {
        if (video.dataset.ready) return;
        video.dataset.ready = 'true';
        if (!reduce && io) io.observe(video);
      });
    };

    const init = () => {
      document.querySelectorAll('[data-hira-carousel]').forEach(setup);
      setupVideos();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hira-customer-results"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const track = root.querySelector('[data-hira-reviews-track]');
      const prev = root.querySelector('[data-hira-reviews-prev]');
      const next = root.querySelector('[data-hira-reviews-next]');

      const step = () => {
        const card = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
      };
      const update = () => {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();

      // Read more: only shown when the quote is actually clamped
      root.querySelectorAll('[data-hira-review-more]').forEach((button) => {
        const quote = document.getElementById(button.getAttribute('aria-controls'));
        if (quote.scrollHeight <= quote.clientHeight + 2) button.hidden = true;
        button.addEventListener('click', () => {
          const open = quote.classList.toggle('is-open');
          button.setAttribute('aria-expanded', String(open));
          button.textContent = open ? 'Read less' : 'Read more';
        });
      });
    };

    const init = () => document.querySelectorAll('[data-hira-reviews]').forEach(setup);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
